export const candidateAttachmentKeys = {
  all: ["candidate-attachments"] as const,
  listForCandidate: (candidateId: string, page: number) => {
    return [...candidateAttachmentKeys.all, candidateId, page] as const;
  },
  // Kept out of `all`, so refreshing the list does not refetch the setting
  allowedExtensions: ["candidate-attachments-allowed-extensions"] as const,
};
